import {
  CardContent,
  Container,
  ContentWithNoLayout,
  Header,
  HeaderContent,
  UpperContainer,
} from "./layout.styled";

type LayoutProps = {
  HeaderChildren?: JSX.Element | JSX.Element[];
  CardChildren?: JSX.Element | JSX.Element[];
  children: JSX.Element | JSX.Element[];
  isLayout: boolean;
};

const Layout = ({
  children,
  HeaderChildren,
  CardChildren,
  isLayout,
}: LayoutProps) => {
  return (
    <>
      {isLayout ? (
        <UpperContainer maxWidth={false} disableGutters>
          {HeaderChildren && (
            <Header>
              <HeaderContent>{HeaderChildren}</HeaderContent>
            </Header>
          )}
          <Container maxWidth={false} disableGutters>
            {CardChildren && <CardContent>{CardChildren}</CardContent>}
            {children}
          </Container>
        </UpperContainer>
      ) : (
        <ContentWithNoLayout>{children}</ContentWithNoLayout>
      )}
    </>
  );
};

export default Layout;
